var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"skeleton-text",class:[_vm.variant, { 'mb-0': !_vm.spacing }],style:({ width: _vm.width, height: _vm.customHeight })})
}
var staticRenderFns = []

export { render, staticRenderFns }